
/**
 * 图片
 * 
 */


const SgiListEO = function () {

    return {
        // disply: "",//图片地址
        // alt: "图片加载失败",//规定图像的替代文本
        ctlH: "100%",
        ctlW: "100%",
        desId: "EP_EO_UI_4107",
        c: '',//
        ctlN: "列表",
        cId: '',//组件编号
        // sc:'',//语义代码
        n: "列表",
        // t: "text",
        te: "我是列表组件x",

    }

}

export { SgiListEO };
export default SgiListEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiListEO.js